import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Moment } from 'moment'
import { TopLayer, SearchProvisioning, ProvisioningInformations, PrettyDatePicker } from './styles'
import { EnvelopeIcon } from 'components/Icons'
import Mails from './Mails'

const ProvisioningMails = () => {
  const { t } = useTranslation()
  const [date, setDate] = useState<Moment | null>(null)

  return (
    <>
      <TopLayer>
        <SearchProvisioning>
          <h4>{t('mails.provisionings.search-title')}</h4>
          <p>{t('global.date')}</p>
          <PrettyDatePicker
            value={date}
            placeholder={t('global.date-format')}
            onChange={ (date) => setDate(date) }
          />
        </SearchProvisioning>
        <ProvisioningInformations>
          <EnvelopeIcon />
          <span>{t('mails.provisionings.informations')}</span>
        </ProvisioningInformations>
      </TopLayer>
      {
        !!date &&
        <Mails date={date} setDate={setDate} />
      }
    </>
  )
}

export default ProvisioningMails
